module.exports = __webpack_public_path__ + "static/media/zappy-jdp-logo.b65c87c5.svg";